// Datafeed implementation, will be added later
import regeneratorRuntime from "regenerator-runtime";
import { deleteCookie, getCookieValue } from './utils/utils'
import {COOKIES, LOCAL_STORAGE} from './utils/enum';
import {getConfig} from '../config';
import {chartConfig, stockDetails} from './utils/config'
import { ENDPOINTS_CONST } from './utils/api-constants';
import LocalStorage from "../services/LocalStorage";
import { checkAllowedUser, getSubscriptionData, irReadynessApi } from "./helper";
import { getAuthToken } from '../services/apiService';

window.modules = {}
window.globalVariable = {}
checkLogin();
getSubscriptionData();

async function bootLoader() {
  // Load Modules
  const { chartState, headerFactory, makeApiCall, bridgeInterface, holidays, holidaysMap, communicate, DateTz, formatDateTime, muhuratMap, isMuhuratDay, weekendOrHoliday, muhuratSessions } = await import("chart_service/exposedFiles");
  let { ENDPOINTS, chartConstants } = await import("chart_service/exposedFiles");
  ENDPOINTS = {
    ...ENDPOINTS,
    ...ENDPOINTS_CONST
  }
  modules = {
    chartState: new chartState(),
    headerFactory,
    makeApiCall,
    ENDPOINTS,
    chartConstants: chartConstants,
    holidays,
    holidaysMap,
    communicate,
    DateTz,
    formatDateTime,
    muhuratMap,
    isMuhuratDay,
    weekendOrHoliday,
    muhuratSessions
  }
  // Instantiate the Instance
  const { initTradingViewInstance } = await import('./chartInstance.js');
  const { initComplete } = await import('../datafeeds/helper')

  window.addEventListener('message', function (event) {
    switch (event.data.actionType) {
      case "initChart":
        window[event.data.actionType](event.data.chartConfig, event.data.stockDetails, event.data.headers, event.data.uniqueChartId, event.data.shareId);
        break;
      case "modifyChart":
        window[event.data.actionType](event.data.chartConfig, event.data.stockDetails, event.data.headers);
        break;
      case "bridgeInterface":
        window[event.data.actionType](event.data.chartConfig)
        break;
      default: break;
    }
  });


function handleReqId() {
  const getRiskDisclosure = () => {
      const riskAcceptance = LocalStorage.get(LOCAL_STORAGE.RISK_DISCLOSURE_ACCEPTANCE, false);
      if (riskAcceptance) {
        window.removeEventListener('storage', getRiskDisclosure);
        globalVariable.riskDiscWindow.close();
        initTradingViewInstance();
      }
    };
    window.addEventListener('storage', getRiskDisclosure);
}


  window.initChart = function (chartConfig, stockDetails, headers, uniqueChartId, shareId = null) {
    globalVariable.stockDetails = stockDetails;
    globalVariable.headers = headers;
    globalVariable.theme = chartConfig.setChartMode.value;
    headerFactory.setHeaders(headers);
    window.uniqueChartId = uniqueChartId;
    if (window.tvWidget) {
      modules.chartState.resetState();
      tvWidget.activeChart().setSymbol(globalVariable.stockDetails.stockId);
      initComplete();
    } else {
      checkAllowedUser().then(() => {
        irReadynessApi().then(() => {
          const riskAcceptance = LocalStorage.get(LOCAL_STORAGE.RISK_DISCLOSURE_ACCEPTANCE, false);
          const showRiskDisclosure = getCookieValue(COOKIES.SHOW_RISK_DISCLOSURE);
          if(globalVariable.kyc === "full") {
            if (!riskAcceptance || showRiskDisclosure) {
              deleteCookie(COOKIES.SHOW_RISK_DISCLOSURE);
              handleReqId();
              const width = 780;
              const height = 558;
              const left = (window.screen.width / 2) - (width / 2);
              const top = (window.screen.height / 2) - (height / 2);
              globalVariable.riskDiscWindow = window.open(
                `${window.location.origin}/stocks/risk-disclosure`,
                'riskDiscWindow',
                `popup=true,top=${top},left=${left},width=${width},height=${height}`,
              );
            } else {
              initTradingViewInstance();
            }
          } else {
            initTradingViewInstance();
          }
        }).catch(() => {
          globalVariable.isIrReady = false;
          initTradingViewInstance();
        })
      })
    }
  }

  window.bridgeInterface = function (chartConfig) {
    bridgeInterface(chartConfig, modules.chartState)
  }

  jsLoadedCb();
}

bootLoader();

async function initialiseChart() {
  try {
    const authToken = await getAuthToken();
    
    const headers = {
      "content-type": "application/json",
      "x-pmngx-key": "paytmmoney",
      "x-sso-token": getCookieValue(COOKIES.SSO_TOKEN),
      "x-user-agent": getCookieValue(COOKIES.USER_AGENT),
      "authorization": "Basic " + authToken
    }
    initChart(chartConfig, stockDetails, headers, Math.floor(Math.random()));
  } catch (error) {
    window.location.href = `${getConfig().AUTH}?pmlEnv=tradingView`;
  }
}

function checkLogin() {
  if(!getCookieValue(COOKIES.SSO_TOKEN)) {
    LocalStorage.deleteItem(LOCAL_STORAGE.RISK_DISCLOSURE_ACCEPTANCE);
    LocalStorage.deleteItem(LOCAL_STORAGE.EDIS_BULK_AUTH_KEY);
    deleteCookie(COOKIES.PASSCODE_VERIFIED);
    window.location.href = `${getConfig().AUTH}?pmlEnv=tradingView`;
  } else if(!getCookieValue(COOKIES.PASSCODE_VERIFIED)) {
    LocalStorage.deleteItem(LOCAL_STORAGE.RISK_DISCLOSURE_ACCEPTANCE);
    LocalStorage.deleteItem(LOCAL_STORAGE.EDIS_BULK_AUTH_KEY);
    window.location.href = `${getConfig().PASSCODE_URL}?pmlEnv=tradingView`;
  }
}

function jsLoadedCb() {
  window.onload = function () {
    initialiseChart();
  }
}